import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../../../components/ui/accordion";
import { ActivityLogList, type ActivityLog } from "./ActivityLogList";

interface ActivityLogSectionProps {
  activityLogs: ActivityLog[];
  logsLoading: boolean;
}

export function ActivityLogSection({
  activityLogs,
  logsLoading,
}: ActivityLogSectionProps) {
  if (activityLogs.length === 0 && !logsLoading) {
    return null;
  }

  return (
    <div className="mt-4">
      <Accordion type="single" collapsible>
        <AccordionItem value="activity" className="border-0">
          <AccordionTrigger className="text-sm font-semibold">
            Activity
          </AccordionTrigger>
          <AccordionContent>
            <ActivityLogList
              activityLogs={activityLogs}
              logsLoading={logsLoading}
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
